/**
 * Trigger browser downloads from in-memory content. Everything stays local — no
 * network request is ever made.
 */

/** Download a Blob as `filename` via a transient object URL. */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** Download text content as `filename` with the given MIME type. */
export function downloadText(
  filename: string,
  content: string,
  mime = "text/plain;charset=utf-8",
): void {
  downloadBlob(filename, new Blob([content], { type: mime }));
}
